function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMuthooth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76.836,
    height: 24,
    viewBox: "0 0 76.836 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "7vc88kv25a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 19743",
    style: {
      fill: "none"
    },
    d: "M0 0h76.836v24H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18482"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18481",
    style: {
      clipPath: "url(#7vc88kv25a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59535",
    d: "M34.972 0c7.508 0 13.6 3.591 13.6 8.019s-6.09 8.019-13.6 8.019-13.6-3.59-13.6-8.019S27.462 0 34.972 0",
    transform: "translate(3.499)",
    style: {
      fillRule: "evenodd",
      fill: "#e50019"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59536",
    d: "m0 21.449 1.651.012c.18-1.1.518-2.288.788-3.381.09-.364.221-.783.282-1.145l.18 2.211c.054.775.112 1.531.1 2.313h1.928c.111-.076.221-.4.284-.536l1.635-3.3c.05-.1.093-.178.136-.266l.1-.2.014-.022.054-.066c-.065.605-.467 2.547-.631 3.324-.079.372-.2.71-.269 1.072h1.675c.091-1.115.674-3.777.946-5.109.108-.533.256-1.125.349-1.652l-2.411-.014a6.322 6.322 0 0 0-.276.6c-.091.19-.192.381-.292.58-.194.386-.379.763-.585 1.164s-.407.762-.59 1.156a12.461 12.461 0 0 1-.6 1.165l-.283-4.644c-.212-.065-2.112-.028-2.491-.02-.237 1.446-.985 4.363-1.444 5.936-.079.27-.193.563-.25.822",
    transform: "translate(0 2.402)",
    style: {
      fillRule: "evenodd",
      fill: "#e50019"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59537",
    d: "m15.7 21.452 1.694.006a16.672 16.672 0 0 1 .472-2.381c.219-.77.485-1.479 1.229-1.657 1.337-.321.972.848.8 1.678-.161.789-.391 1.585-.539 2.355h1.685c.135-1.093.762-3.611.691-4.279-.127-1.2-1.665-1.247-2.495-1.055a3.2 3.2 0 0 0-.9.4c.087-.639.3-1.228.44-1.828h-1.671c-.138 1.263-.86 4.576-1.2 5.931-.066.265-.171.576-.214.832",
    transform: "translate(2.57 2.404)",
    style: {
      fillRule: "evenodd",
      fill: "#e50019"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59538",
    d: "M28.936 17.281c.994-.244 1.288.333 1.128 1.246-.125.713-.4 1.316-1.05 1.466-.993.228-1.291-.343-1.14-1.244.122-.737.411-1.309 1.062-1.469m.248-1.408a3.141 3.141 0 0 0-1.968.845 2.837 2.837 0 0 0-.6.779 3.777 3.777 0 0 0-.37 1.04c-.412 1.971.63 3.029 2.581 2.849a3.15 3.15 0 0 0 2.884-2.692c.385-1.912-.627-2.988-2.529-2.821",
    transform: "translate(4.282 2.595)",
    style: {
      fillRule: "evenodd",
      fill: "#e50019"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59539",
    d: "M23.9 17.275c1.021-.242 1.267.381 1.111 1.287-.125.723-.422 1.3-1.081 1.439-.969.2-1.263-.376-1.1-1.272.129-.723.412-1.3 1.072-1.455m.283-1.407a3.151 3.151 0 0 0-2.973 2.622c-.424 1.967.555 3.057 2.53 2.9a3.138 3.138 0 0 0 2.916-2.659c.4-1.906-.57-3.009-2.473-2.863",
    transform: "translate(3.457 2.595)",
    style: {
      fillRule: "evenodd",
      fill: "#e50019"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59540",
    d: "m36.313 21.458 1.732-.013.029-.008a.178.178 0 0 0 .03-.009c.072-.469.138-.948.23-1.408s.218-.927.306-1.379c.438-.01.883 0 1.321 0s.917.035 1.344.029a10.947 10.947 0 0 0 .33-1.526c-.415 0-.865.05-1.3.051h-1.37a4.621 4.621 0 0 1 .261-1.057c.8-.087 2.322.069 2.98.023l.313-1.467h-4.734c-.155 1.144-.765 3.91-1.048 5.106-.128.54-.321 1.135-.42 1.664",
    transform: "translate(5.944 2.404)",
    style: {
      fillRule: "evenodd",
      fill: "#e50019"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59541",
    d: "M51.312 18.972c-.022.178-.086.394-.127.575-.073.326 0 .327-.3.4-.26.065-.895.27-1.124.074-.148-.126-.069-.374.041-.486a7.113 7.113 0 0 1 1.514-.564m-2.281-1.279c.6-.211 1.883-.922 2.551-.446.062.457-.464.547-.841.646-1.2.314-2.418.518-2.686 1.815-.311 1.507 1 1.875 2.259 1.586.171-.038.177-.019.247-.156.1-.2.365-.883.488-1.04a3.943 3.943 0 0 1-.131.59c-.055.193-.142.394-.18.581h1.755c.121-1.143.552-2.639.746-3.833a1.234 1.234 0 0 0-.278-1.217c-.624-.613-2.339-.337-3.234-.147-.275.058-.225.019-.346.428-.1.347-.29.861-.348 1.194",
    transform: "translate(7.859 2.593)",
    style: {
      fillRule: "evenodd",
      fill: "#e50019"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59542",
    d: "m45.477 16.34.037-.34a9 9 0 0 0-1.537.026 7.339 7.339 0 0 0-.258 1.321c-.086.457-.172.889-.272 1.342-.1.435-.192.86-.292 1.284-.1.439-.243.869-.328 1.3h1.678a10.767 10.767 0 0 0 .214-1.208c.185-1 .485-2.58 1.507-2.828 1.336-.325.971.841.8 1.672-.143.7-.44 1.8-.54 2.362h1.686c.132-1.08.763-3.616.691-4.275-.134-1.228-1.707-1.25-2.547-1.047a2.718 2.718 0 0 0-.839.4",
    transform: "translate(7.01 2.594)",
    style: {
      fillRule: "evenodd",
      fill: "#e50019"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59543",
    d: "m55.065 16.342.043-.342-1.547-.01-.521 2.67c-.1.429-.19.866-.292 1.286s-.26.9-.332 1.32h1.669a7.423 7.423 0 0 0 .223-1.2c.2-1.037.468-2.568 1.5-2.829.355-.09.918-.12.968.392a23.82 23.82 0 0 1-.7 3.633l1.685.009c.094-.7.24-1.419.375-2.113a8.964 8.964 0 0 0 .317-2.167c-.083-.741-.613-1.039-1.374-1.11a3.616 3.616 0 0 0-1.178.066 2.879 2.879 0 0 0-.833.4",
    transform: "translate(8.58 2.595)",
    style: {
      fillRule: "evenodd",
      fill: "#e50019"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59544",
    d: "m11.145 20.9-.052.346h1.54l.136-.651c.175-1.019.441-2.354.689-3.34a12.653 12.653 0 0 0 .3-1.285c-2.09.084-1.569-.46-1.872 1.225-.184 1.022-.482 2.582-1.515 2.821-1.309.3-.953-.847-.784-1.693.072-.365.526-2.182.512-2.349H8.454c-.085.3-.13.744-.189 1.062a20.409 20.409 0 0 0-.524 3.2c.087.758.59 1.047 1.365 1.124a3.658 3.658 0 0 0 1.175-.063 3.222 3.222 0 0 0 .862-.4",
    transform: "translate(1.266 2.611)",
    style: {
      fillRule: "evenodd",
      fill: "#e50019"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59545",
    d: "M63.751 17.7a.935.935 0 0 1 .725-.56c.482-.071.675.1.674.562zm1.733 3.467.616-1.607a3.881 3.881 0 0 1-1.744.413 1.058 1.058 0 0 1-.79-.282c-.144-.152-.282-.685-.083-.832h3.041c.4-1.371.332-2.68-1.064-2.942-3.1-.58-4.5 3.166-3.42 4.7.715 1.01 2.059.843 3.443.557",
    transform: "translate(10.097 2.595)",
    style: {
      fillRule: "evenodd",
      fill: "#e50019"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59546",
    d: "M61.99 19.649c-1.145.294-2.907.794-2.453-1.1a1.524 1.524 0 0 1 .966-1.183 2.029 2.029 0 0 1 .966-.055c.327.055.582.165.875.222l.235-1.45a3.9 3.9 0 0 0-3.336.324 3.484 3.484 0 0 0-1.4 2.69c-.214 3.159 3.475 2.173 3.64 2.066a8.987 8.987 0 0 0 .511-1.517",
    transform: "translate(9.466 2.597)",
    style: {
      fillRule: "evenodd",
      fill: "#e50019"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59547",
    d: "M32.515 15.315c-.207 1.01-.042.815-.916.817l-.28 1.3h.663a12.75 12.75 0 0 1-.315 1.527c-.229 1.044-.816 2.252.516 2.529a4.751 4.751 0 0 0 1.712-.065 11.73 11.73 0 0 0 .538-1.451 5.684 5.684 0 0 1-.978.2c-.505.007-.333-.432-.251-.79.147-.648.283-1.3.434-1.952h1.208a13.113 13.113 0 0 0 .249-1.3h-1.147l.226-1.107z",
    transform: "translate(5.127 2.459)",
    style: {
      fillRule: "evenodd",
      fill: "#e50019"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59548",
    d: "m14.258 15.316-.179.81h-.725l-.291 1.3h.67a13.328 13.328 0 0 1-.319 1.514 12.226 12.226 0 0 0-.332 1.538c-.057 1.339 1.594 1.048 2.586.94l.513-1.439c-.22-.008-.662.189-1 .19-.481 0-.321-.421-.24-.775l.445-1.967h1.173a6.691 6.691 0 0 0 .284-1.3h-1.152l.225-1.1z",
    transform: "translate(2.138 2.459)",
    style: {
      fillRule: "evenodd",
      fill: "#e50019"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59549",
    d: "m40.784 21.2 1.711.013c.083-.784.3-1.734.453-2.51.125-.635.456-2.009.522-2.487h-1.62c-.073.176-.192 1.035-.24 1.284-.078.42-.163.831-.253 1.257-.164.781-.452 1.81-.574 2.443",
    transform: "translate(6.676 2.653)",
    style: {
      fillRule: "evenodd",
      fill: "#e50019"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59550",
    d: "M41.753 16.13h1.619l.306-1.441H42.05z",
    transform: "translate(6.835 2.404)",
    style: {
      fillRule: "evenodd",
      fill: "#e50019"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59551",
    d: "M30.134 7.268a6.935 6.935 0 0 1 .752.182l2.232.592-2.992-.007zM25.4 13.036c.52-.006 3.461.037 3.7-.02V8.377c1.1-.1 2.469-.12 2.958.662a1.172 1.172 0 0 1-.19 1.4c-.442.412-1.324.055-1.331.538-.007.62 1.324 1.078 2.425.051A3.933 3.933 0 0 0 34.189 8.5c.218-2.3-1.492-3.958-2.721-4.723a10.333 10.333 0 0 0-6.055-1.426zM30.568 5.3c.227.058.391.178.369.266s-.226.113-.452.055-.392-.178-.369-.268.225-.113.452-.054",
    transform: "translate(4.157 .382)",
    style: {
      fill: "#fafafa",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59552",
    d: "M37.223 7.268a6.983 6.983 0 0 0-.751.182l-2.233.592 2.993-.007zm4.737 5.768c-.52-.006-3.461.037-3.7-.02V8.377c-1.1-.1-2.469-.12-2.959.662a1.173 1.173 0 0 0 .191 1.4c.442.412 1.324.055 1.331.538.007.62-1.324 1.078-2.425.051A3.933 3.933 0 0 1 33.17 8.5c-.218-2.3 1.492-3.958 2.721-4.723a10.333 10.333 0 0 1 6.055-1.426zM36.79 5.3c-.227.058-.391.178-.369.266s.226.113.452.055.392-.178.369-.268-.226-.113-.452-.054",
    transform: "translate(5.427 .382)",
    style: {
      fill: "#fafafa",
      fillRule: "evenodd"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuthooth);
export default __webpack_public_path__ + "static/media/muthooth.b02be9e3a1a304af4fb023523e0a8615.svg";
export { ForwardRef as ReactComponent };